import { useTranslation } from 'react-i18next';
import StepContainer from '../../components/onboarding/StepContainer';
import PlatformCard from '../../components/onboarding/PlatformCard';
import { useOnboardingStore } from '../../stores/onboardingStore';

interface Platform {
  id: string;
  name: string;
  description: string;
  icon: string;
}

const PLATFORMS: Platform[] = [
  {
    id: 'linkedin',
    name: 'LinkedIn',
    description: 'Professional content and B2B marketing',
    icon: '💼',
  },
  {
    id: 'instagram',
    name: 'Instagram',
    description: 'Visual storytelling through photos and reels',
    icon: '📸',
  },
  {
    id: 'facebook',
    name: 'Facebook',
    description: 'Reach broad audiences with posts and videos',
    icon: '👥',
  },
  {
    id: 'twitter',
    name: 'Twitter / X',
    description: 'Quick updates and real-time conversations',
    icon: '🐦',
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    description: 'Short-form video content',
    icon: '🎵',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    description: 'Video platform for long-form content',
    icon: '🎥',
  },
];

export default function PlatformsStep() {
  const { t } = useTranslation();
  const { selectedPlatforms, togglePlatform, nextStep, previousStep } = useOnboardingStore();

  const handleNext = () => {
    // TODO: In production, save to backend
    // await apiClient.patch(`/workspace/${workspaceId}/platforms`, { platforms: selectedPlatforms });
    nextStep();
  };

  const handleSkip = () => {
    // Skip platform selection
    nextStep();
  };

  return (
    <StepContainer
      title={t('onboarding.platforms.title')}
      description={t('onboarding.platforms.subtitle')}
      onNext={handleNext}
      onBack={previousStep}
      showSkip={true}
      onSkip={handleSkip}
    >
      <div className="space-y-6">
        {/* Info Text */}
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {t('onboarding.platforms.infoText')}
        </p>

        {/* Platform Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {PLATFORMS.map((platform) => (
            <PlatformCard
              key={platform.id}
              platform={platform}
              isSelected={selectedPlatforms.includes(platform.id)}
              onToggle={togglePlatform}
            />
          ))}
        </div>

        {/* Selection Counter */}
        <div className="text-center p-4 border-2 border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800">
          <p className="text-sm font-semibold dark:text-gray-100">
            {selectedPlatforms.length} {t('onboarding.platforms.platformsSelected')}
          </p>
        </div>
      </div>
    </StepContainer>
  );
}
